import { getCurrentUser, getUserPermissions } from "src/utils/permissionsUtils";
import SvgColor from "../../../components/svg-color";

type NavItem = {
	key: string;
	title: string;
	path: string;
	icon: JSX.Element;
};

const icon = (name: string, size: string = "medium") => {
	const sizeConfig = {
		small: { width: 0.6, height: 0.6 },
		medium: { width: 1, height: 1 },
	};

	return <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={sizeConfig[size]} />;
};

const { isSuperAdmin, isClient } = getUserPermissions();
const currentUser = getCurrentUser();
const userMenuItems = currentUser?.admin?.menuItems || [];

// Helper function to filter menu items based on client permissions
const filterForClient = (config: NavItem[]) => {
	return isClient ? config.filter((item) => userMenuItems.includes(item.key)) : config;
};

const mainConfig: NavItem[] = [
	...(isSuperAdmin
		? [
				{
					key: "admins",
					title: "Admins",
					path: "/dashboard/admins",
					icon: icon("lock-outline"),
				},
			]
		: []),
	{
		key: "users",
		title: "Users",
		path: "/dashboard/users",
		icon: icon("ic_user"),
	},
	{
		key: "coin-transactions",
		title: "Coin Transactions",
		path: "/dashboard/coin-transactions",
		icon: icon("behance-outline"),
	},
	{
		key: "settings",
		title: "Settings",
		path: "/dashboard/app-settings",
		icon: icon("settings-outline"),
	},
	// {
	// 	key: "inbox",
	// 	title: "Inbox",
	// 	path: "/dashboard/inbox",
	// 	icon: icon("email-outline"),
	// },
];

export default filterForClient(mainConfig);

export const homeConfig: NavItem[] = filterForClient([
	{
		key: "home",
		title: "Home",
		path: "/dashboard/home",
		icon: icon("home-outline"),
	},
]);

export const appConfig: NavItem[] = filterForClient([
	{
		key: "users",
		title: "Users",
		path: "/dashboard/users",
		icon: icon("users", "small"),
	},
	...(isSuperAdmin
		? [
				{
					key: "admins",
					title: "Admins",
					path: "/dashboard/admins",
					icon: icon("lock-outline"),
				},
			]
		: []),
	{
		key: "inbox",
		title: "Inbox",
		path: "/dashboard/inbox",
		icon: icon("notes", "small"),
	},
	{
		key: "settings",
		title: "Settings",
		path: "/dashboard/settings",
		icon: icon("settings-outline"),
	},
]);

export const storeConfig: NavItem[] = filterForClient([
	{
		key: "coin-transactions",
		title: "Coin Transactions",
		path: "/dashboard/coin-transactions",
		icon: icon("transactions"),
	},
	{
		key: "marketplace",
		title: "Marketplace",
		path: "/dashboard/marketplace?tenant=football",
		icon: icon("shopping-cart-outline"),
	},
	{
		key: "voucher",
		title: "Vouchers",
		path: "/dashboard/vouchers",
		icon: icon("transactions"),
	},
]);

export const newsConfig: NavItem[] = filterForClient([
	{
		key: "categories",
		title: "News Categories",
		path: "/dashboard/news-categories",
		icon: icon("entries"),
	},
	{
		key: "news",
		title: "News",
		path: "/dashboard/news",
		icon: icon("packs-icon"),
	},
]);

export const videoConfig: NavItem[] = filterForClient([
	{
		key: "video-categories",
		title: "Video Categories",
		path: "/dashboard/video-categories",
		icon: icon("entries"),
	},
	{
		key: "videos",
		title: "Videos",
		path: "/dashboard/videos",
		icon: icon("packs-icon"),
	},
]);

export const arcadeConfig: NavItem[] = filterForClient([
	{
		key: "games",
		title: "Games",
		path: "/dashboard/arcade",
		icon: icon("arcade"),
	},
]);
